import { updateImageResolution } from '@/modules/utils/image';
import { Image, type ImageProps } from '@volkswagen-onehub/components-core';

export enum VWImageQuality {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export const VWIMAGE_SIZES = {
  [VWImageQuality.LOW]: '512',
  [VWImageQuality.MEDIUM]: '1024',
  [VWImageQuality.HIGH]: '2048',
};

interface Props extends ImageProps {
  quality?: VWImageQuality;
}

function VWImage(props: Props) {
  const { src, quality } = props;

  let newSrc;

  if (quality && src) {
    newSrc = updateImageResolution(src, VWIMAGE_SIZES[quality]);
  }

  return <Image {...props} src={newSrc ?? src} />;
}

export default VWImage;
